import { LogoWellmaxx } from './LogoWellmaxx'

export default LogoWellmaxx
